// client/src/hooks/useReports.js
import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api.js';

export function useFairDaySummary(campId) {
  return useQuery({
    queryKey: ['camps', campId, 'reports', 'fair-day-summary'],
    queryFn: () => api.get(`/api/camps/${campId}/reports/fair-day-summary`),
    enabled: !!campId,
    staleTime: 60_000,
  });
}
